<div class="mat-elevation-z8">
	<table mat-table matSort [dataSource]="dataSource">
		<ng-container matColumnDef="id">
			<th mat-header-cell *matHeaderCellDef> ID </th>
			<td mat-cell *matCellDef="let row"> {{ row.message.id }} </td>
		</ng-container>
	
		<ng-container matColumnDef="parcInfo">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Parc(s) </th>
			<td mat-cell *matCellDef="let row">
				<div *ngFor="let parcLabel of row.parcsLabels">{{ parcLabel }}</div>
			</td>
		</ng-container>
	
		<ng-container matColumnDef="emetteur">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Emetteur/R&eacute;cepteur </th>
			<td mat-cell *matCellDef="let row"> {{ row.message.emetteur ? "Emetteur" : "R&eacute;cepteur" }}</td>
		</ng-container>
	
		<ng-container matColumnDef="dateMessage">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
			<td mat-cell *matCellDef="let row"> {{ row.message.dateMessage | displayLocalTimeWithoutSeconds }} </td>
		</ng-container>
	
		<ng-container matColumnDef="nomAgent">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Nom agent </th>
			<td mat-cell *matCellDef="let row"> {{ [row.message.agentNom, row.message.agentPrenom].join(' ') }} </td>
		</ng-container>
	
		<ng-container matColumnDef="agentNum">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> N&deg; agent </th>
			<td mat-cell *matCellDef="let row"> {{ row.numero }} </td>
		</ng-container>
	
		<ng-container matColumnDef="correspondantEntite">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Entit&eacute; correspondant </th>
			<td mat-cell *matCellDef="let row"> {{ row.message.correspondantEntite }} </td>
		</ng-container>
	
		<ng-container matColumnDef="correspondantNom">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Nom correspondant </th>
			<td mat-cell *matCellDef="let row"> {{ row.message.correspondantNom }} </td>
		</ng-container>
	
		<ng-container matColumnDef="correspondantNum">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> N&deg; correspondant </th>
			<td mat-cell *matCellDef="let row"> {{ row.message.correspondantNum }} </td>
		</ng-container>
	
		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClick(row.message)"></tr>
	</table>
	
	<mat-paginator #paginator
		showFirstLastButtons
		[pageSizeOptions]="[5, 10, 20, 50]"
		[pageSize]="10"
		aria-label="Choisissez une page">
	</mat-paginator>
</div>